import { z } from 'zod'

export const OrganizationMemberSchema = z.object({
  userId: z.string().uuid('無効なユーザーIDです。'),
  employeeNumber: z.string().max(50).optional().nullable(),
  departmentName: z.string().max(200).optional().nullable(),
  positionName: z.string().max(100).optional().nullable(),
  parentId: z.string().uuid().optional().nullable(),
})

export type OrganizationMemberInput = z.infer<typeof OrganizationMemberSchema>
